import React from "react";
import { Input, Row, Col, Button, Card, Spin, Form } from "antd";
import { SelectionInput } from "../../common/SelectionInput";
import PropTypes from "prop-types";
import { RecordType } from "../../model/common/RecordType";
import EntryFormFooter from "../../common/EntryFormFooter";
import { useTranslation } from "react-i18next";

const ManageRoleTypesForm = ({
  isLoading,
  roleType,
  types,
  onSubmitted,
  onCancelled,
  form,
  setIsDirty,
}) => {
  const { t } = useTranslation();
  const formats = { cellSpacing: 20 };
  const disableField = roleType.RcdType === RecordType.USER ? false : true;

  const handleSubmit = async () => {
    form.validateFields().then((values) => {
      onSubmitted(values);
    });
  };

  return (
    <Spin spinning={isLoading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        onValuesChange={() => setIsDirty(true)}
      >
        <Row>
          <Col
            xs={{ span: 24, offset: 0 }}
            sm={{ span: 24, offset: 0 }}
            xl={{ span: 24, offset: 0 }}
            xxl={{ span: 16, offset: 4 }}
          >
            <Card
              title={
                <span className="form-title">
                  {t("roleTypesForm.role_setup")}
                </span>
              }
            >
              <Row
                gutter={formats.cellSpacing}
                style={{
                  marginTop: 16,
                }}
              >
                <Col xs={24} lg={12}>
                  <Form.Item
                    label={t("roleTypesForm.role_code")}
                    name="RoleTypeCode"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: t(
                          "roleTypesForm.role_code_required_validation"
                        ),
                      },
                      {
                        max: 100,
                        message: t(
                          "roleTypesForm.role_code_max_length_validation"
                        ),
                      },
                    ]}
                    initialValue={roleType.RoleTypeCode}
                  >
                    <Input
                      placeholder={t("roleTypesForm.role_code_placeholder")}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={12}>
                  <Form.Item
                    label="Description"
                    name="RoleTypeDesc"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: t("general.description_required_validation"),
                      },
                      {
                        max: 250,
                        message: t("general.description_max_length_validation"),
                      },
                    ]}
                    initialValue={roleType.RoleTypeDesc}
                  >
                    <Input placeholder={t("general.description_placeholder")} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={formats.cellSpacing}>
                <Col xs={24} lg={12}>
                  <Form.Item
                    label={t("roleTypesForm.role_type")}
                    style={{ margin: 0 }}
                    name="Type"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "roleTypesForm.role_type_required_validation"
                        ),
                      },
                    ]}
                    initialValue={
                      roleType.Type > 0
                        ? {
                            key: roleType.Type,
                            value: roleType.Type,
                            label: roleType.TypeDesc,
                          }
                        : undefined
                    }
                  >
                    <SelectionInput
                      ref={React.createRef()}
                      labelInValue={true}
                      data={types}
                      valueProp={"Key"}
                      textProp={"Desc"}
                      placeholder={t("roleTypesForm.role_type_placeholder")}
                      disabled={disableField}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Row className="save-section">
              <Col style={{ textAlign: "right", padding: "10px" }}>
                <Button
                  size="large"
                  type="default"
                  onClick={onCancelled}
                  style={{ marginRight: "5px" }}
                >
                  {t("general.cancel")}
                </Button>
                <Button size="large" type="primary" htmlType="submit">
                  {t("general.save")}
                </Button>
              </Col>
            </Row>
            <EntryFormFooter
              footerData={roleType}
              showFooter={roleType.RoleTypeKey !== -1 ? true : false}
              isApproved={false}
              isVoid={false}
              isPending={false}
              t={t}
            ></EntryFormFooter>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

ManageRoleTypesForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  roleType: PropTypes.object.isRequired,
  types: PropTypes.array.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  onCancelled: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  setIsDirty: PropTypes.func.isRequired,
};

export default ManageRoleTypesForm;
